import { useMemo } from 'react';
import { useHotkeys } from 'react-hotkeys-hook';

import { useEditCanvasStore } from '../../store';

export function useToolShortcuts() {
  const canvasMode = useEditCanvasStore((state) => state.canvasMode);
  const setActiveTool = useEditCanvasStore((state) => state.setActiveTool);
  const readOnly = useEditCanvasStore((state) => state.readOnly);

  const baseEnabled = canvasMode.mode === 'default';

  const options = useMemo(() => ({ enabled: baseEnabled && !readOnly, preventDefault: true }), [baseEnabled, readOnly]);

  const readOnlyOptions = useMemo(() => ({ enabled: baseEnabled, preventDefault: true }), [baseEnabled]);

  useHotkeys('h', () => setActiveTool('hand'), readOnlyOptions, [setActiveTool]);
  useHotkeys('v', () => setActiveTool('select'), readOnlyOptions, [setActiveTool]);
  useHotkeys('t', () => setActiveTool('text'), options, [setActiveTool]);
}
